import React from "react";
// import Category from "./CategorySection";
// import Course from "./CourseSection";
import AcademicLevelsSection from "./AcademicLevelsSection";
import HomeBanner from "./HomeBanner";
import WhyChooseUs from "./WhyChooseUsSection";

const HomeMain = () => {
  return (
    <main>
      <HomeBanner />
      <AcademicLevelsSection />
      {/* <Category /> */}
      {/* <Course /> */}
      <WhyChooseUs />
    </main>
  );
};
export default HomeMain;
